import apiService from "./api"
import envService from "./env"

export default {
    $api : apiService(),
    $env : envService(),
}